<template>
  <v-app>
    <Header title="Unavailable Block Type">
      <v-btn dark :to="{ name: 'createUnavailableBlockTypes' }" color="#ae1431" elevation="0">
        <v-icon left> mdi-plus</v-icon>
        <span class="d-none d-sm-inline">Add Unavailable Block Type</span>
      </v-btn>
    </Header>

    <v-container fluid>
      <v-card class="mt-5">
        <v-data-table
            :headers="headers"
            :items="unavailableBlockTypes"
            :items-per-page="1000"
            hide-default-footer
            class="elevation-1"
            style="cursor: pointer"
            @click:row="Edit"
        >

          <template v-slot:item.name="{ item }">

            <div class="color-label">
              <span class="color-circle"  :style="{ backgroundColor:  item.color }"></span>
              <span>{{item.name}}</span>
            </div>


          </template>

        </v-data-table>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Header from '../../../components/Header.vue';
import apolloClient from "@/apollo/apollo";
import gql from "graphql-tag";

export default {
  components: { Header },
  data() {
    return {
      unavailableBlockTypes: [],
      headers: [
        { text: 'Name', align: 'start', value: 'name' },
        { text: 'Duration', value: 'durationInMint' },
      ],
    }
  },
  methods: {
    Edit(appointmentTypeService) {
      // this.$store.dispatch('setSingleAppointmentTypeService', appointmentTypeService)
      this.$router.push({
        name: 'EditUnavailableBlockTypes',
        params: { id: appointmentTypeService.id, payload: appointmentTypeService }
      });
    },
  },
  mounted() {
    try {
      apolloClient.query({
        query: gql`
          query findAllAppointmentTypeServices {
            findAllAppointmentTypeServices(filter: {type: BLOCKING}){
              id
              name
              durationInMint
              color
            }
          }
        `,
        context: {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
          },
        },
      }).then(response => {
        this.unavailableBlockTypes = response.data.findAllAppointmentTypeServices;
      });
    } catch (error) {
      console.error("Failed to fetch users:", error);
    }
  }
};
</script>

<style>
.v-toolbar__content,
.v-toolbar__extension {
  justify-content: space-between;
  width: 100%;
}

.v-data-table__wrapper {
  overflow-x: auto;
}

.v-data-table {
  width: 100%;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  background-color: #a8e3e1;
}

@media (max-width: 600px) {
  .v-btn__content .v-icon {
    margin-right: 0;
  }
}
</style>

<style>
.color-label {
  display: flex;
  align-items: center;
  margin: 5px 0;
}

.color-circle {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
  border: 1px solid #ccc; /* optional: border to see it on white bg */
}
</style>
